import { useEffect } from 'react';
import { SwiftypePage, SwiftypeResponse } from './models';

const SWIFTYPE_API_KEY = 'ez5_Vx_hNyshKX_ZXDwu';
const SWIFTYPE_URL = `https://search-api.swiftype.com/api/v1/public/installs/${SWIFTYPE_API_KEY}/suggest.json`;
const DEBOUNCE_DELAY_MS = 250;
const PAGE = 1;

interface UseSwiftypeApiArgs {
  text: string;
  onSuccess: (pages: SwiftypePage[]) => void;
  onError: () => void;
}

export const useSwiftypeApi = ({
  text,
  onSuccess,
  onError,
}: UseSwiftypeApiArgs) => {
  useEffect(() => {
    const debouncedFetch = setTimeout(async () => {
      if (!text.trim()) {
        onSuccess([]);
        return;
      }

      try {
        const response = await fetch(SWIFTYPE_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: `q=${encodeURIComponent(text)}&page=${PAGE}`,
        });

        if (response.ok) {
          const data: SwiftypeResponse = await response.json();
          onSuccess(data.records.page);
          return;
        }

        throw new Error(response.statusText);
      } catch (error) {
        console.error('Search request error:', error);
        onError();
      }
    }, DEBOUNCE_DELAY_MS);

    return () => clearTimeout(debouncedFetch);
  }, [text]);
};
